<template>
  <v-container fluid>
    <div>
      <create-digi-board-type
        v-if="showCreateForm"
        @success="getDigiBoardTypes"
        @closed="showCreateForm = false"
      />
    </div>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-monitor-cellphone
      </v-icon>   DigiBoard Types
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createDigiBoardType()"
        >
          Create New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="digiBoardTypes"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>
              {{ item.placement }}
            </td>
            <td>
              {{ item.position }}
            </td>
            <td>
              {{ item.display_type }}
            </td>
            <td>{{ item.created_at | convertStringToLocalDatetime }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="red"
                @click.stop
                @click="deleteDigiBoardType()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import CreateDigiBoardType from './CreateDigiBoardType.vue';

  export default {
    name: 'DigiBoardTypesList',
    components: {
      'centre-spinner': spinner,
      'create-digi-board-type': CreateDigiBoardType,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Mounting Type', value: 'placement' },
          { text: 'Location Type', value: 'position' },
          { text: 'Screen Type', value: 'display_type' },
          { text: 'Created At', value: 'created_at' },
          { text: 'Delete', value: 'delete' },
        ],
        showCreateForm: false,
      };
    },
    computed: {
      digiBoardTypes () {
        return this.$store.getters['digiboards/getDigiBoardTypesList'];
      },
    },
    async mounted () {
      await this.getDigiBoardTypes();
    },
    methods: {
      async getDigiBoardTypes () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchDigiBoardTypesList');
        this.loading = false;
      },
      deleteDigiBoardType () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Sorry you are not authorized to delete any time slots from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      createDigiBoardType () {
        this.showCreateForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table {
  background-color: #ECEFF1;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
</style>
